import React, { useId, useState } from 'react';
import { Box, Button, Dialog, DialogActions, DialogContent, DialogTitle, FormControlLabel, IconButton, Radio, RadioGroup, Stack, Typography } from '@mui/material';
import HelpOutline from '@mui/icons-material/HelpOutline';
import { FitbitExportDateBasis } from '../../../services/fitbitExtractionService';
import { useCollectionServices } from '../../../contexts/CollectionSourceContext';

export default function FitbitExportTimeChoice({ value, onChange, disabled = false, daily = false }: {
  value: FitbitExportDateBasis; onChange: (value: FitbitExportDateBasis) => void; disabled?: boolean; daily?: boolean;
}) {
  const { source } = useCollectionServices();
  const [help, setHelp] = useState(false);
  const id = useId();
  return <Box sx={{ border: '1px solid', borderColor: 'divider', borderRadius: '10px', px: 1.5, py: .75 }}>
    <Stack direction="row" alignItems="center" justifyContent="space-between">
      <Typography id={id} variant="body2" fontWeight={600}>Timezone for participant</Typography>
      <IconButton size="small" aria-label="About export time zones" aria-haspopup="dialog" onClick={() => setHelp(true)}><HelpOutline fontSize="small" /></IconButton>
    </Stack>
    <RadioGroup row aria-labelledby={id} value={value} onChange={event => onChange(event.target.value as FitbitExportDateBasis)}>
      <FormControlLabel value="recorded_local" control={<Radio size="small" />} disabled={disabled} label="Participant timezone" sx={{ '& .MuiFormControlLabel-label': { fontSize: 13 } }} />
      <FormControlLabel value="utc" control={<Radio size="small" />} disabled={disabled} label="UTC timezone" sx={{ '& .MuiFormControlLabel-label': { fontSize: 13 } }} />
    </RadioGroup>
    <Dialog open={help} onClose={() => setHelp(false)} maxWidth="sm" fullWidth aria-labelledby={`${id}-help`}>
      <DialogTitle id={`${id}-help`}>Timezone for participant</DialogTitle>
      <DialogContent><Stack spacing={1.5}>
        <Typography variant="body2">You can choose UTC timezone or participant timezone for your extraction dates.</Typography>
        <Typography variant="body2"><strong>Participant timezone:</strong> {source.id === 'ultrahuman'
          ? 'uses the time zone saved for the participant’s Ultrahuman connection.'
          : 'based on the local time information Fitbit saves with each reading.'}</Typography>
        <Typography variant="body2"><strong>UTC timezone:</strong> uses UTC dates for everyone, regardless of location.</Typography>
        {daily && <Typography variant="body2">The time your daily extraction runs is set separately.</Typography>}
      </Stack></DialogContent>
      <DialogActions><Button onClick={() => setHelp(false)}>Got it</Button></DialogActions>
    </Dialog>
  </Box>;
}
